import React from 'react';
import Input from './input';
import Button from './button';
import Error from './error_message';
import setValue from '../../helpers/set_value';
import { useAngularService } from '../../helpers/get_angular_service';

interface AutopaymentsEzidebitFormProps {
  errors: any;
  paymentSystemAccount: any;
  save: () => void;
  setForm: (form: any) => void;
}

const AutopaymentsEzidebitForm = ({
  errors,
  paymentSystemAccount,
  save,
  setForm,
}: AutopaymentsEzidebitFormProps) => {
  const $modal = useAngularService('$modal');

  const confirm = () => {
    const modalInstance = $modal.open({
      template: require('templates/gyms/payers/confirm_ezidebit_link.html.slim'),
      controller: 'ConfirmModalCtrl',
    });

    modalInstance.result.then(() => {
      save();
    });
  };

  return (
    <div>
      <div className="clearfix payment-provider">
        <div className="payment-provider-logo">
          <img alt="Ezidebit" src="/ezidebit.png" />
        </div>
        <p>
          Ezidebit is one of the simplest ways to save time, improve your cash flow and attract new
          business.
        </p>
      </div>
      <div className="form-group row">
        <label className="col-sm-3">Ezidebit Client ID</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.account_id}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'account_id', value));
            }}
          />
          <Error error={errors['payment_system_account.response']} />
          <Error error={errors['payment_system_account.account_id']} />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-3">Public Key</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.public_key}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'public_key', value));
            }}
          />
          <Error error={errors['payment_system_account.public_key']} />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-sm-3">Digital Key</label>
        <div className="col-sm-6">
          <Input
            value={paymentSystemAccount.secret_key}
            onChange={(value) => {
              setForm(setValue(paymentSystemAccount, 'secret_key', value));
            }}
          />
          <Error error={errors['payment_system_account.secret_key']} />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-3"></div>
        <div className="col-sm-6 ">
          <Button
            variant="success"
            onClick={confirm}
            disabled={
              !paymentSystemAccount.account_id ||
              !paymentSystemAccount.secret_key ||
              !paymentSystemAccount.public_key
            }
          >
            Connect
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutopaymentsEzidebitForm;
